import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { traverseDom } from '@fi-shared/utils/traverse-dom';

@Injectable({
    providedIn: 'root',
})
export class FiHighlightService {
    private highlightText: string;
    private renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    setHighlightText(text: string) {
        this.highlightText = text;
    }

    getHighlightLayout(contentBody: string) {
        if (this.highlightText) {
            const highlightTextArray = this.highlightText.split(',');
            const el = this.renderer.createElement('div');
            el.innerHTML = contentBody;
            highlightTextArray.forEach((highlightText: string) => {
                traverseDom(
                    el,
                    (node) => {
                        this.insertHighlightSpan(node, highlightText);
                    },
                    [Node.TEXT_NODE],
                );
            });
            return el.innerHTML;
        }
        return contentBody;
    }

    private insertHighlightSpan(node, highlightText) {
        if (node.parentNode) {
            let nodeTextContentLowerCase = node.textContent.toLowerCase();
            const highlightTextLowerCase = highlightText.toLowerCase();
            const idx = nodeTextContentLowerCase.indexOf(highlightTextLowerCase);
            if (idx !== -1) {
                let equalText = node.textContent.substr(idx, highlightText.length);
                const secondTextNode = node.splitText(idx);
                secondTextNode.textContent = secondTextNode.textContent.slice(highlightText.length);
                const spanEl = this.renderer.createElement('span');
                spanEl.className = 'ContentTextHighlight';
                const spanText = this.renderer.createText(equalText);
                this.renderer.appendChild(spanEl, spanText);
                this.renderer.insertBefore(node.parentNode, spanEl, secondTextNode);
                this.insertHighlightSpan(secondTextNode, highlightText);
            }
        }
    }
}
